import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IndexPath } from '@/Config/app/router/index.path';
import { TopicUnavailableGraphics } from '@/Domain/components/Insights/Topics/TopicUnavailable.graphics';

export const ManageTopicsProtected = () => {
  const { t } = useTranslation('insights_page');

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-3">
      <TopicUnavailableGraphics />
      <p className="font-medium">{t('manage_topic_protected.title')}</p>
      <p className="text-sm text-foreground-subtle text-center">
        <Trans
          i18nKey="insights_page:manage_topic_protected.topic_settings"
          components={{
            setting_link: (
              <Link to={`../${IndexPath.subscription}`} className="text-foreground font-medium" />
            ),
          }}
        />
      </p>
    </div>
  );
};
